import { Suspense } from 'react';
import { lazily } from 'react-lazily';

import { AppLayout } from '.';
import { AppContent } from '../../app/app-content';

const { GlobalModals } = lazily(() => import('../../app/global-modals'));

export const AppRootLayout = () => {
	return (
		<AppLayout>
			<Suspense>
				<GlobalModals />
			</Suspense>

			<AppContent />
		</AppLayout>
	);
};
